import React from 'react'
import { Accordion, Card, ListGroup } from 'react-bootstrap'

const Activities = ({term, petitions, questions, submitters, proponents}) => {
  return (
    <div style={{ paddingBottom: '5px' }}>
      <h5>任期: {term.from} 〜 {term.to}</h5>
      <Accordion>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey='0'>
            議会での質問 {questions.length}件
          </Accordion.Toggle>
          <Accordion.Collapse eventKey='0'>
            <Card.Body>
              <ListGroup variant='flush'>
                {questions.map((question, idx) => {
                  return <ListGroup.Item key={idx}><a href={question.url} rel='noopener noreferrer' target='_blank'>{question.title}</a></ListGroup.Item>;
                })}
              </ListGroup>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey='1'>
            提出議案 {submitters.length}件
          </Accordion.Toggle>
          <Accordion.Collapse eventKey='1'>
            <ListGroup variant='flush'>
              {submitters.map((node, idx) => {
                return <ListGroup.Item key={idx}><a href={node.url} rel='noopener noreferrer' target='_blank'>{node.title}</a></ListGroup.Item>;
              })}
            </ListGroup>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey='2'> 
            議員提出に賛同した議案 {proponents.length}件
          </Accordion.Toggle>
          <Accordion.Collapse eventKey='2'>
            <ListGroup variant='flush'>
             {proponents.map((node, idx) => {
                return <ListGroup.Item key={idx}><a href={node.url} rel='noopener noreferrer' target='_blank'>{node.title}</a></ListGroup.Item>;
              })}
            </ListGroup>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey='3'>
            紹介請願 { petitions.length }件
          </Accordion.Toggle>
          <Accordion.Collapse eventKey='3'>
            <ListGroup variant='flush'>
              {petitions.map((node, idx) => {
                return <ListGroup.Item key={idx}><a href={node.url} rel='noopener noreferrer' target='_blank'>{node.title}</a></ListGroup.Item>;
              })}
            </ListGroup>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Activities;
